import React from 'react'

type Props = {
    className?: string
}

export const PauseIcon = (props: Props) => {
    const { className = "w-5 h-5" } = props
    return (
        <svg fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className}>
            <rect x="14" y="3" width="5" height="18" rx="1"/>
            <rect x="5" y="3" width="5" height="18" rx="1"/>
        </svg>
    )
}
